/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import Logo from './lui-logo'
import globalCssLogo from 'lui-logo.global.scss'
import Product from './lui-productlogo'
import globalCssProduct from 'lui-productlogo.global.scss'

window.lui.registerComponent(Logo, globalCssLogo)
window.lui.registerComponent(Product, globalCssProduct)



//////////////////
// WEBPACK FOOTER
// ./packages/lui-logo/index.js
// module id = 232
// module chunks = 0 1 10